<template>
  <div class="course_box" data-spy="scroll" data-target="#navbar-example">
    <div id="navbar-example">
      <ul class="nav nav-pills nav-stacked" role="tablist">
        <li role="presentation" class="active"><a href="#nm">内蒙</a></li>
        <li role="presentation"><a href="#gy">贵阳</a></li>
        <li role="presentation"><a href="#sc">四川</a></li>
      </ul>
    </div>
    <div class="right">
      <div class="item" id="nm"></div>
      <div class="item" id="gy"></div>
      <div class="item" id="sc"></div>
    </div>
  </div>
</template>
<style lang="less" scoped>
@import "course.less";
</style>
<script>
$('body').scrollspy({ target: '#navbar-example' })
</script>


// WEBPACK FOOTER //
// src/pages/course/course.vue